



























import { Component, Mixins, Ref, Vue } from 'vue-property-decorator'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import FileDropArea from '@/components/common/atoms/FileDropArea.vue'
import LinkArea from '@/components/academy/organisms/LinkArea.vue'
import ModalUserAdd from '@/components/academy/organisms/ModalUserAdd.vue'
import ModalNicknameUpdate from '@/components/academy/organisms/ModalNicknameUpdate.vue'
import ModalPasswordUpdate from '@/components/academy/organisms/ModalPasswordUpdate.vue'
import TeacherForBranchTable from '@/components/academy/organisms/TeacherForBranchTable.vue'
import TeacherForBranchApis, {
  BranchData,
  TeacherForBranchData,
} from '@/mixins/requests/academy/TeacherForBranchApis.vue'
import PaginationButton from '@/components/common/organisms/PaginationButton.vue'

@Component({
  components: {
    InputSimple,
    SelectBase,
    ButtonBase,
    TeacherForBranchTable,
    FileDropArea,
    LinkArea,
    ModalUserAdd,
    ModalNicknameUpdate,
    ModalPasswordUpdate,
    PaginationButton,
  },
})
export default class TeacherForBranch extends Mixins(TeacherForBranchApis) {
  private bcbtCode!: string

  private branchData: BranchData | null = null
  private teacherForBranchList: TeacherForBranchData[] = []

  private gradeOptions = []

  private isManagerDefault: { [bcbtCode: string]: boolean } = {}
  private isManager: { [bcbtCode: string]: boolean } = {}

  // ref: 講師追加モーダル
  @Ref() modalUserAdd!: ModalUserAdd
  // ref: 氏名変更モーダル
  @Ref() modalNicknameUpdate!: ModalNicknameUpdate
  // ref: パスワード変更モーダル
  @Ref() modalPasswordUpdate!: ModalPasswordUpdate
  // ref: ページネーション
  @Ref() paginationButton!: PaginationButton

  private get branchId() {
    return this.$route.params['branchId']
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      this.branchData = await this.getBranch(this.branchId)
      this.loadTeacherForBranchList()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 講師一覧表示の更新
   */
  private async loadTeacherForBranchList() {
    const teacherForBranchObject = await this.searchTeacherForBranch(
      this.paginationButton.paginationCurrentPage,
      this.branchId
    )
    this.teacherForBranchList = teacherForBranchObject.responses
    this.paginationButton.paging(teacherForBranchObject.pagination)
    // 教室長フラグ初期化
    this.isManager = {}
    // 教室長フラグ初期状態保持
    this.teacherForBranchList.forEach((data) => {
      this.isManagerDefault[data.bcbtCode] = data.isManager
    })
  }

  /**
   * 教室長フラグ保持
   */
  private checkManager(bcbtCode: string, checked: boolean) {
    this.isManager[bcbtCode] = checked
  }

  /**
   * 教室長フラグ設定保存
   */
  private async onClickSaveManager() {
    // 送信用配列成形
    let updateQuery: { bcbtCode: string; isManager: boolean }[] = []
    Object.keys(this.isManager).forEach((bcbtCode: string) => {
      updateQuery.push({ bcbtCode: bcbtCode, isManager: this.isManager[bcbtCode] })
    })

    if (confirm('教室長設定を保存しますか？')) {
      Vue.prototype.$loading.start()
      await this.teacherIsManagerUpdateApi(
        this.branchId,
        updateQuery,
        () => {
          this.loadTeacherForBranchList()
          alert('更新成功')
        },
        () => {
          alert('エラーが発生しました')
        }
      )
      Vue.prototype.$loading.complete()
    } else {
      this.loadTeacherForBranchList()
    }
  }

  /**
   * ユーザ（講師）追加モーダル表示
   */
  private async onClickAddTeacher() {
    this.modalUserAdd.init()
    this.modalUserAdd.show()
  }

  /**
   * ユーザ（講師）追加処理 (モーダルからイベント検知)
   */
  private async userTeacherAdd() {
    Vue.prototype.$loading.start()
    try {
      await this.userTeacherAddApi(
        this.branchId,
        this.modalUserAdd.nickname,
        this.modalUserAdd.password,
        () => {
          this.modalUserAdd.hide()
          this.loadTeacherForBranchList()
        },
        (err: any) => {
          if (err.response.data.status === 400) {
            this.modalUserAdd.setErrorMessage(err.response.data.message)
          } else {
            alert('エラーが発生しました')
          }
        }
      )
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 氏名変更モーダル表示
   */
  private onClickNicknameUpdateButton(bcbtCode: string) {
    this.bcbtCode = bcbtCode
    this.modalNicknameUpdate.init()
    this.modalNicknameUpdate.show()
  }

  /**
   * 氏名変更処理 (モーダルからイベント検知)
   */
  private async userNicknameUpdate() {
    Vue.prototype.$loading.start()
    try {
      await this.userNicknameUpdateApi(
        this.bcbtCode,
        this.modalNicknameUpdate.nickname,
        () => {
          this.modalNicknameUpdate.hide()
          this.loadTeacherForBranchList()
        },
        (err: any) => {
          if (err.response.data.status === 400) {
            this.modalNicknameUpdate.setErrorMessage(err.response.data.message)
          } else {
            alert('エラーが発生しました')
          }
        }
      )
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * パスワード変更モーダル表示
   */
  private onClickPasswordUpdateButton(bcbtCode: string) {
    this.bcbtCode = bcbtCode
    this.modalPasswordUpdate.init()
    this.modalPasswordUpdate.show()
  }

  /**
   * パスワード変更処理 (モーダルからイベント検知)
   */
  private async userPasswordUpdate() {
    Vue.prototype.$loading.start()
    try {
      await this.userPasswordUpdateApi(
        this.bcbtCode,
        this.modalPasswordUpdate.password,
        this.modalPasswordUpdate.comfirmPassword,
        () => {
          this.modalPasswordUpdate.hide()
          this.loadTeacherForBranchList()
          alert('更新成功')
        },
        (err: any) => {
          if (err.response.data.status === 400) {
            this.modalPasswordUpdate.setErrorMessage(err.response.data.message)
          } else {
            alert('エラーが発生しました')
          }
        }
      )
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 講師削除ボタン
   */
  private async onClickDeleteButton(bcbtCode: string) {
    // 取込処理
    this.bcbtCode = bcbtCode
    if (confirm('削除しますか？')) {
      Vue.prototype.$loading.start()
      await this.userDeleteApi(
        this.bcbtCode,
        () => {
          this.loadTeacherForBranchList()
        },
        () => {
          alert('エラーが発生しました')
        }
      )
      Vue.prototype.$loading.complete()
    }
  }

  private async onClickPaginationButton() {
    await this.loadTeacherForBranchList()
  }
}
